// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__svIsO","buttons":"Footer_buttons__1Je_r"};